import { createSlice } from '@reduxjs/toolkit'

export const carSlice = createSlice({
    name: 'car',
    initialState: {
        cars_list: {

        }
    },
    reducers: {
        setCarsList: (state, data) => {
            console.log("before", state.cars_list)
            state.cars_list = data.payload
            console.log("after", state.cars_list)
        }
    }
})

// Action creators are generated for each case reducer function
export const { setCarsList } = carSlice.actions

export default carSlice.reducer